<template>
  <div id="bookings">

    <div class="tabs">
      <div class="tab" :class="{active: !completed}" @click="changeFilter(false)">{{ $t("booking.status.in_progress") }}</div>
      <div class="tab" :class="{active: completed}" @click="changeFilter(true)">{{ $t("booking.status.done") }}</div>
      <div class="filler"></div>
    </div>

    <div class="content" :class="{desktop: $store.state.isDesktop, cogir: $store.state.cogir}">
      <div class="bookings">
        <template v-if="isInitialized">
          <div class="booking" v-for="booking of bookings" :key="booking.id" @click="goTo(booking.id)"
               :class="{selected: selectedBooking && selectedBooking.id === booking.id}" v-if="booking.getEntity()">
            <div class="image">
              <svgicon v-if="$store.state.cogir" src="svg/octo.svg" :height="50" :width="50"></svgicon>
              <svgicon v-if="!$store.state.cogir" src="svg/humaniti.svg" :height="50" :width="50"></svgicon>
            </div>
            <div class="middle">
              <v-clamp class="title" :max-lines="1" v-if="booking.getEntity().getService()">{{ $to(booking.getEntity().getService().name) }}</v-clamp>
              <div class="subtitle">
                <span v-if="booking.getEntity().group">{{$to(booking.getEntity().group.name)}} - </span>
                {{ $to(booking.getEntity().name) }}
              </div>
              <div class="message">
                {{$t('booking.start')}} : {{ booking.start.format("DD/MM/YYYY - HH:mm") }}<br>
                {{$t('booking.end')}} : {{ booking.end.format("DD/MM/YYYY - HH:mm") }}
              </div>
            </div>
            <div class="arrow" v-show="!$store.state.isDesktop">
              <svgicon src="svg/arrow.svg" :width=11 :height=20></svgicon>
            </div>
          </div>
        </template>
        <div class="empty" v-if="bookings.length === 0 || !isInitialized">{{$t('booking.empty')}}</div>
      </div>

      <div class="booking-info" v-if="$store.state.isDesktop">
        <div class="placeholder" v-if="!selectedBooking">
          <img v-if="!$store.state.cogir" src="@/assets/img/logo.png">
          <img v-if="$store.state.cogir" src="@/assets/img/icons/octo-white.png" class="cogir">
        </div>
        <div class="info" v-if="selectedBooking">
          <div class="title">{{$t('booking.details')}}</div>
          <div class="groups">
            <div class="group" v-if="selectedBooking.getEntity() && selectedBooking.getEntity().service">
              <label>{{$t('booking.service.label')}}</label>
              <div class="value">{{$to(selectedBooking.getEntity().getService().name)}}</div>
            </div>
            <div class="group">
              <label>{{$t('booking.number')}}</label>
              <div class="value">#{{selectedBooking.id}}</div>
            </div>
            <div class="group">
              <label>{{$t('booking.calendar')}}</label>
              <div class="value">
                <span v-if="selectedBooking.getEntity().group">{{$to(selectedBooking.getEntity().group.name)}} - </span>
                {{$to(selectedBooking.getEntity().name)}}
              </div>
            </div>
            <div class="group">
              <label>{{$t('booking.booking_start')}}</label>
              <div class="value">{{ selectedBooking.start.format("DD/MM/YYYY - HH:mm") }}</div>
            </div>
            <div class="group">
              <label>{{$t('booking.booking_end')}}</label>
              <div class="value">{{ selectedBooking.end.format("DD/MM/YYYY - HH:mm") }}</div>
            </div>
            <div class="group">
              <label>{{$t('booking.price')}}</label>
              <div class="value">{{selectedBooking.total.toFixed(2)}}$</div>
            </div>
          </div>
        </div>
        <div class="buttons" v-if="isCancelable">
          <div class="btn btn-secondary" @click="cancel">{{$t('booking.cancel')}}</div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <router-link to="/new-booking" class="btn btn-primary">
        {{$t("booking.new")}}
      </router-link>
    </div>

  </div>
</template>

<script>

  import Schedules from "../../core/Schedules";
  import EventGroups from "../../core/EventGroups";
  import Reservations from "../../core/Reservations";
  import moment from 'moment';

  export default {

    name: "Bookings",

    async mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "page.bookings",
        headerIcon: "/svg/date.svg"
      });
      showSpinner(); //TODO not showing
      await Schedules.init();
      await EventGroups.init();
      await Reservations.init();
      this.isInitialized = true;
      hideSpinner();
    },

    data() {
      return {
        Schedules,
        Reservations,
        EventGroups,
        completed: false,
        selectedBooking: null,
        isInitialized: false
      }
    },

    computed: {
      bookings() {
        if (this.completed) {
          return this.Reservations.reservations.filter(b => {
            return b.end.isBefore(moment()) && !b.cancelled;
          });
        }

        return this.Reservations.reservations.filter(b => {
          return moment().isBefore(b.end) && !b.cancelled;
        });
      },
      isCancelable() {
        return this.selectedBooking && this.selectedBooking.getEntity().price === 0
                && !(this.completed || this.selectedBooking.getEntity().cancelled);
      }
    },

    methods: {
      goTo(id) {
          if (!this.$store.state.isDesktop) {
            this.$router.push("/booking/" + id);
          } else {
              this.selectedBooking = this.bookings.find(b => b.id === id);
          }
      },
      changeFilter(value) {
        this.completed = value;
        this.selectedBooking = null;
      },
      async cancel() {
        if(this.isCancelable){
          let confirmed = await showConfirmation(this.$t('booking.cancel'), this.$t('booking.cancel_text'), this.$t('yes'), this.$t('no'));
          if(!confirmed) {
            return;
          }

          showSpinner();
          try {
            let result = await this.selectedBooking.cancelReservation();
            hideSpinner();
          } catch(e) {
            showAffirmation(this.$t("error"), this.$to(e.response.data.message));
            hideSpinner();
            return;
          }
          this.selectedBooking.cancelled = true;
          this.selectedBooking = null;
        }
      }
    }

  }

</script>

<style lang="scss" scoped>

  #bookings {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }

  .content {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;

    &.desktop {
      display: flex;

      .bookings, .booking-info {
        flex-grow: 1;
        flex-basis: 0;
      }
    }
  }

  .empty {
    color: #888;
  }

  .booking-info {
    margin-left: 40px;
    border: 1px solid #f4f4f4;
    display: flex;
    flex-direction: column;
    .buttons {
      justify-content: flex-end;
    }
  }

  .placeholder {
    background-color: rgba(255,255,255,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px;
    img {
      width: 100%;
      filter: brightness(0);
      opacity: 0.08;
      max-width: 200px;

      &.cogir {
        max-width: 70px;
      }
    }
  }

  .buttons {
    flex-shrink: 0;
    padding: 20px;
  }

  .tabs {
    background-color: #001722;
    border-top: 1px solid #405159;
    color: #808b91;
    display: flex;
    flex-shrink: 0;

    .tab {
      flex-grow: 1;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      flex-basis: 0;

      &.active {
        color: white;
        font-weight: bold;
        box-shadow: inset 0 -4px #405159;
      }
    }
  }

  .cogir {
    .booking.selected {
      border: 3px solid #1a1a1a;
    }
  }

  .booking {
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    cursor: pointer;

    &.selected {
      border: 3px solid #001722;
    }
    &:not(.selected) {
      .middle {
        border: 3px solid transparent;
        border-left: 0;
      }
      .image {
        width: 103px;
        border-left: 3px solid #f2f3f4;
      }
    }
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
    .image {
      min-height: 100px;
      width: 100px;
      flex-shrink: 0;
      background-color: #f2f3f4;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      .svgicon {
        fill: #808b91;
      }
    }
    .middle {
      flex-grow: 1;
      padding: 10px 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .subtitle {
        color: #808b91;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .message {
        color: #405159;
        font-size: 14px;
      }
      .title {
        word-break: break-all;
        font-weight: 500;
      }
    }
    .arrow {
      width: 30px;
      background-color: #f2f3f4;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      .svgicon {
        fill: #808b91;
      }
    }
  }

  .booking-info .info {
    background-color: white;
    padding: 30px;

    .title {
      font-weight: bold;
      font-size: 18px;
      padding-bottom: 5px;
      margin-bottom: 15px;
      border-bottom: 1px solid #f2f3f4;
    }

    .group {
      margin-bottom: 15px;

      label {
        font-size: 14px;
      }
    }
  }

  .groups {
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-height: 700px) {
    .groups .group {
      width: 50%;
    }
    .groups {
      flex-wrap: wrap;
      max-height: 250px;
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #bookings {
      padding:30px 60px 30px 60px;
    }
    .content {
      padding: 20px;
      margin-left: -20px;
      margin-right: -20px;
    }
    .booking .middle {
      padding-left: 15px;
    }
    .tabs {
      background-color: #f2f3f4;
      margin-bottom: 30px;
      border-top: none;

      .filler {
        flex-grow: 1;
        border-bottom: 5px solid #e6e6e6;
      }
      .tab {
        min-width:175px;
        padding: 0 18px;
        flex-grow: 0;
        font-size: 16px;
        line-height: 1;
        text-align: center;
        text-decoration: none;
        border-bottom: 5px solid #e6e6e6;
        transition: border-bottom-color 0.2s ease-in-out;
        color: #808080;
        cursor: pointer;
        &.active, &.router-link-active {
          color: #404040;
          font-weight: 500;
          border-bottom: 5px solid #808b91;
          box-shadow: none;
        }
        &:hover {
          border-bottom: 5px solid #808b91;
        }
        &.disabled {
          color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
        }
      }
    }
    .bookings {
      overflow-y: auto;
      padding: 15px;
      margin-left: -15px;
    }
    .buttons {
      display: flex;
      justify-content: flex-start;
      padding-left: 0;
      padding-right: 0;
    }
  }

</style>
